import {trackpointMetrics} from 'lib/metricsCalculator'
import _ from 'lodash'
import {getConsole} from 'lib/getConsole'
const console = getConsole('lib', 'routeUtils')

/**
 * Operations in this utils file should be immutable.  None the data structures are immutable, but they should be treated as such.
 * Any changes to the track point data should be performed on rawPoints and when completed, trackPoints should be updated with the results of trackpointMetrics(newRawPoints)
 */

export const flattenElevation = (route, startIndex, endIndex) => {
  // This method will only work on routes, and expectes the points at the given indexes to have a distance, and elevation.
  // If you need to adapt this to a ride, you'll probably want to make your own method and that might trigger the route.geom refactor.

  const {rawPoints} = route

  const a = rawPoints[startIndex]
  const b = rawPoints[endIndex]
  const slope = (b.e - a.e) / (b.d - a.d)

  const before = rawPoints.slice(0, startIndex)
  const toFlatten = rawPoints.slice(startIndex, endIndex)
  const after = rawPoints.slice(endIndex)

  const flattened = toFlatten.map(p => Object.assign({}, p, {e: (p.d - a.d) * slope + a.e}))

  const rawPointsWithFlattened = before.concat(flattened, after)
  return route.set('rawPoints', rawPointsWithFlattened).set('trackPoints', trackpointMetrics(rawPointsWithFlattened))
}

export const excludeFromMetrics = (route, startIndex, endIndex) => {
  const rawPoints = route.rawPoints || []

  const before = rawPoints.slice(0, startIndex)
  const toExclude = rawPoints.slice(startIndex, endIndex)
  const after = rawPoints.slice(endIndex)

  const excluded = toExclude.map(raw => Object.assign({}, raw, {k: true}))

  const rawPointsWithExcluded = before.concat(excluded, after)
  return route.set('rawPoints', rawPointsWithExcluded).set('trackPoints', trackpointMetrics(rawPointsWithExcluded))
}

export const includeInMetrics = (route, startIndex, endIndex) => {
  const rawPoints = route.rawPoints || []

  const before = rawPoints.slice(0, startIndex)
  const toInclude = rawPoints.slice(startIndex, endIndex)
  const after = rawPoints.slice(endIndex)

  const included = toInclude.map(raw => _.omit(raw, 'k'))

  const rawPointsWithExcluded = before.concat(included, after)
  return route.set('rawPoints', rawPointsWithExcluded).set('trackPoints', trackpointMetrics(rawPointsWithExcluded))
}

export const parseRawTrackPoints = (rawPoints) => {
  return window.rwgps.TrackPoint.fromJSON(rawPoints).trackPoints
}

export const sanitizeTrackPoints = (route, slice) => {
  const {sanitizedPoints, indexMapping} = getSanitizedTrackPointsWithMapping(route.trackPoints)
  if (!slice) { return sanitizedPoints }
  const sliceStart = indexMapping[slice[0]]
  const sliceEnd = indexMapping[slice[1]]
  const newSlice = sanitizedPoints.slice(sliceStart, sliceEnd)
  return newSlice
}

// filter out route trackPoints that are missing a lat/lng,
// and return the filtered points along with an array used to
// lookup the index of a sanitized point from the index of a
// non-sanitized point in O(1) time
export const getSanitizedTrackPointsWithMapping = _.memoize(trackPoints => {
  const indexMapping = Array(trackPoints.length)
  const sanitizedPoints = Array(trackPoints.length)
  let sanitizedIndex = 0
  for (let i = 0; i < trackPoints.length; i++) {
    const routePoint = trackPoints[i]
    if (Number.isFinite(routePoint.lat) && Number.isFinite(routePoint.lng)) {
      sanitizedPoints[sanitizedIndex] = routePoint
      indexMapping[i] = sanitizedIndex
      sanitizedIndex++
    } else {
      indexMapping[i] = sanitizedIndex
    }
  }
  sanitizedPoints.length = sanitizedIndex
  console.log(`getSanitizedTrackPointsWithMapping cache miss for a ${trackPoints.length}-point trackPoint array (${trackPoints.length - sanitizedPoints.length} points filtered)`)

  return {sanitizedPoints, indexMapping}
})

export const getSliceBounds = (route, slice) => sanitizeTrackPoints(route, slice).reduce((bounds, point) => {
  if (point.lat < bounds[0].lat) bounds[0].lat = point.lat
  if (point.lng < bounds[0].lng) bounds[0].lng = point.lng
  if (point.lat > bounds[1].lat) bounds[1].lat = point.lat
  if (point.lng > bounds[1].lng) bounds[1].lng = point.lng
  return bounds
}, [{lat: 90, lng: 180}, {lat: -90, lng: -180}])
